import { apiService } from './api';

/**
 * Generated Project Details Interface
 */
export interface GeneratedDetails {
  title: string;
  categories: string[];
  description: string;
  playInstructions: string;
}

/**
 * AI Service Response Interface
 */
interface GenerateDetailsResponse {
  success: boolean;
  data: GeneratedDetails;
  usage: {
    tokensUsed: number;
    estimatedCost: number;
  };
}

/**
 * AIService
 * Handles AI-powered features like code generation and project details
 */
class AIService {
  /**
   * Generate project details from game code
   * @param projectId - Project ID
   * @param code - Optional game HTML/JS code (backend will fetch if not provided)
   * @returns Generated project details
   */
  async generateProjectDetails(projectId: string, code?: string): Promise<GeneratedDetails> {
    const response = await apiService.post<GenerateDetailsResponse>(
      '/editor/ai/generate-details',
      { projectId, code },
      { timeout: 180000 }
    );
    
    return response.data.data;
  }
}

export default new AIService();

